





















































































  import Vue from 'vue'
  import { AssessmentStatusService } from '@/services/'
  import BaseIcon from '../svgicons/BaseIcon.vue'
  import { Button } from 'view-design'
  import UISpinner from '@/components/common/UISpinner.vue'
  import { adminMode } from '@/helper/permission.helper'
  export default Vue.extend({
    props: {
      post: Object,
      categoryId: String
    },
    computed: {
      submissionColor(): string {
        return this.lastSubmission.status === "passed" ? "green" : "red";
      },
      postId(): string {
        return this.post ? this.post.id : ''
      },
      isAdmin() {
        return adminMode()
      },
      postContentType(): string {
        return this.post.contentType
      },
      buttonLabel(): string {
        return `${this.lastSubmission ? 'Retake' : 'Start'} ${this.contentTypeLabel[this.postContentType]}`
      }
    },
    data() {
      return {
        lastSubmission: null,
        questionCount: 0,
        correctCount: 0,
        incorrectCount: 0,
        fetchingSubmission: false,
        contentTypeLabel: {
          quiz: 'Quiz',
          assignment: 'Assignment'
        }
      };
    },
    async mounted() {
        await this.getLastSubmission();
    },
    methods: {
      async getLastSubmission() {
        if (this.isAdmin) return // don't make api calls if it's admin
        this.fetchingSubmission = true
        try {
          const fetchedSubmission = await AssessmentStatusService.getLastSubmissionByPostId(this.postId)
          this.lastSubmission = fetchedSubmission.data.lastSubmission;
          if (this.lastSubmission) {
            this.questionCount = this.lastSubmission.submission.length;
            this.correctCount = this.lastSubmission.submission.filter(e => e.correctAnswerGiven).length;
            this.incorrectCount = this.lastSubmission.submission.filter(e => !e.correctAnswerGiven).length;
            this.$emit('changeQuizStatus', true)
          } else {
            this.$emit('changeQuizStatus', false)
          }
        }
        catch (error) {
            console.error(`Error getting last submission`, error);
        }
        this.fetchingSubmission = false
      }
    },
    components: { BaseIcon, Button, UISpinner }
})
